
import { useCallback, useEffect, useMemo, useState } from "react";
import { DataTable } from "../../dataTables/data-table"
import { deteleBeaconStore, fetchBeaconsStore } from "@/apiCalls/apiCalls";
import { Button } from "@/components/ui/button";
import { BeaconsStoreColumns, BeaconStore } from "@/pages/beaconStore/BeaconStoreColumns";
import Spinner from "../spinnner/Spinner";
import AddBeaconStoresDrawer from "./AddBeaconStoresDrawer";
import UpdateBeaconStoresDrawer from "./UpdateBeaconStoreDrawer";
import useAuth from "@/hooks/useAuth";
import { jwtDecode } from "jwt-decode"
import { BeaconStoreDataTables } from "./BeaconStoreDataTables";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import { errorNotification, successNotification } from "@/utils/Notification";
import axios from "axios";


export default function BeaconStoresFn() {
    const [data, setData] = useState<BeaconStore[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [showUpdateBeaconStoresDrawer, setShowUpdateBeaconStoresDrawer] = useState(false)
    const [showAddBeaconStoresDrawer, setShowAddBeaconStoresDrawer] = useState(false)
    const [beaconStoresData, setBeaconStoreData] = useState<BeaconStore | undefined>(undefined)
    const { auth } = useAuth()
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()



    const getBeaconStores = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/beaconStore', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: BeaconStore[]) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false
            controller.abort()
        };
    };


    useEffect(() => {
        getBeaconStores()
    }, [])

    const getClientIPAndURL = async () => {
        try {
            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }

    const deteleBeaconStoreById = (beconTypeId: any) => {
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.delete(`/api/v1/beaconStore/${beconTypeId}`, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((response: any) =>
            response.data.data
        ).then((data: any) => {
            if (isMounted) {
                successNotification(
                    "BeaconStore successfully deleted",
                    `Beacon Type with id ${beconTypeId} was deleted`,
                    'topRight'
                );

            }
            getBeaconStores()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const editFunctionCall = (beaconStore: BeaconStore) => {
        setBeaconStoreData(beaconStore)
        setShowUpdateBeaconStoresDrawer(!showUpdateBeaconStoresDrawer)
    }

    const deleteFunctionCall = async (beaconStore: BeaconStore) => {
        deteleBeaconStoreById(beaconStore.id)
    }


    const onDelete = useCallback(
        (beaconStore: BeaconStore) => deleteFunctionCall(beaconStore),
        []
    )

    const onEdit = useCallback(
        (beaconStore: BeaconStore) => editFunctionCall(beaconStore),
        []
    )


    const beaconsStoresColumnsData = useMemo(() => BeaconsStoreColumns({ onEdit, onDelete, roles }), [])
    if (loading) {
        return <Spinner />
    }

    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>

            {roles.includes('beacon-store-create') && (
                <Button
                    variant='default'
                    className="flex items-center justify-end"
                    onClick={() => setShowAddBeaconStoresDrawer(!showAddBeaconStoresDrawer)}
                >
                    ADD Beacon Stores
                </Button>
            )}
            <BeaconStoreDataTables columns={beaconsStoresColumnsData} data={data} filterNameColumn="uuid" />


            {roles.includes('beacon-store-create') && (
                <AddBeaconStoresDrawer
                    showAddBeaconStoresDrawer={showAddBeaconStoresDrawer}
                    setShowAddBeaconStoresDrawer={setShowAddBeaconStoresDrawer}
                    getBeaconStores={getBeaconStores}
                />

            )}

            {beaconStoresData && roles.includes('beacon-store-edit') && (
                <UpdateBeaconStoresDrawer
                    showUpdateBeaconStoresDrawer={showUpdateBeaconStoresDrawer}
                    setShowUpdateBeaconStoresDrawer={setShowUpdateBeaconStoresDrawer}
                    BeaconStore={beaconStoresData}
                    getBeaconStores={getBeaconStores}
                    setBeaconStoreData={setBeaconStoreData}
                />
            )}
        </main>
    )
}